import { Field, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import { LinkList } from '@ahc-digital/component-library';
import { GetLinkListModel } from './C08LinkList.service';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export type C08LinkListProps = RenderingProps<C08LinkListFields, RenderingParams>;

export type C08LinkListFields = {
  Title?: Field<string>;
  SupportingCopy?: RichTextField;
  BottomCTA?: LinkField;
};

export type RenderingParams = {
  TitleType?: string;
  TitleAlignment?: string;
  BackgroundTheme?: string;
  NumberOfColumns?: string;
  CTAStyle?: string;
  ColumnAlignment?: string;
  SupportCopyAlignment?: string;
  CTAAlignment?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;

export const Default = (props?: C08LinkListProps) => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  const model = GetLinkListModel(props);
  return (
    <LinkList
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...model}
    />
  );
};
